/*
 *  Mobile Menu
 *    Scripts for the mobile menu
 *
 *  Version:
 *    1.0.0 - 2019/04/15
 */
import $ from 'jquery';
import Cookies from 'js-cookie';
import { t } from '@process-creative/slate-theme-tools';

export const MOBILE_MENU_SELECTOR = '[data-mobile-menu]';
export const MOBILE_MENU_TOGGLE = '[data-mobile-menu-toggle]';
export const MOBILE_MENU_SUBMENU = '[data-mobile-submenu]';
export const MOBILE_SEARCH = '[data-mobile-menu-search]';
export const MOBILE_MENU_BACK = '[data-mobile-menu-back]';


export const MOBILE_SUBMENU_TOGGLE = '[data-mobile-submenu-toggle]';
export const MOBILE_SEARCH_TOGGLE = '[data-mobile-menu-search-toggle]';

export const CLASS_MENU_OPEN = 'is-menu-open';

export const CLASS_SUBMENU_OPEN = 'is-submenu-open';
export const CLASS_SEARCH_OPEN = 'is-mobile-menu-search-open';


const RECENTLY_VIEWED_URL = 'data-recently-viewed-url';

export class MobileMenu {
  constructor(container) {
    this.container = container;

    this.menuTargets = [container,$('html,body')];
    this.recentlyViewedURL = $(`[${RECENTLY_VIEWED_URL}]`).attr(RECENTLY_VIEWED_URL);

    //find the last li of mobile menu
    this.submenuLast = this.container.
      find('nav.c-mobile-menu ul.c-mobile-menu__menu:not(.is-additional)\
            li.c-mobile-menu__item:not(.c-mobile-menu__submenu-item)').last();

    this.submenuToggle = container.find(MOBILE_SUBMENU_TOGGLE);
    this.firstSubMenuToggle = this.submenuToggle.first();

    this.submenu = container.find(MOBILE_MENU_SUBMENU);

    this.mobileSearch = $(MOBILE_SEARCH);

    this.mobileBack = $(MOBILE_MENU_BACK)

    container.on('click touch', MOBILE_MENU_TOGGLE, e => this.onMenuToggle(e));
    container.on('click touch', MOBILE_SUBMENU_TOGGLE, e => this.onSubmenuToggle(e));
    $(document).on('click touch', MOBILE_SEARCH_TOGGLE, e => this.onSearchToggle(e));

    container.on('click touch', MOBILE_MENU_BACK, e => {
      let parentContainer = $(e.currentTarget).closest(MOBILE_MENU_SUBMENU).prev(MOBILE_SUBMENU_TOGGLE);
      parentContainer.next(MOBILE_MENU_SUBMENU).toggleClass(CLASS_SUBMENU_OPEN);
      parentContainer.toggleClass(CLASS_SUBMENU_OPEN);
      this.container.removeClass(CLASS_SUBMENU_OPEN);
    });

    //add recently viewed link if the user has viewed product
    if (this.recentlyViewedURL) this.addRecentlyViewedLink();
  }

  open() {
    this.menuTargets.forEach(e => {
      e.addClass(CLASS_MENU_OPEN);
    });
  }

  close() {
    this.menuTargets.forEach(e => {
      e.removeClass(CLASS_MENU_OPEN);
      e.removeClass(CLASS_SUBMENU_OPEN);
      e.find(`.${CLASS_SUBMENU_OPEN}`).removeClass(CLASS_SUBMENU_OPEN);
    });
  }

  toggleOpen() {
    if(this.container.hasClass(CLASS_MENU_OPEN)) return this.close();
    this.open();
    e.removeClass(CLASS_SUBMENU_OPEN);
    // this.openFirstSubmenu();
  }

  toggleSubmenu(e) {
    let { currentTarget } = e;
    let subToggle = $(currentTarget);
    subToggle.next(MOBILE_MENU_SUBMENU).toggleClass(CLASS_SUBMENU_OPEN);
    subToggle.toggleClass(CLASS_SUBMENU_OPEN);

    // extra class for AB test sliding nav TODO integrate if test adopted
    if(this.container.find(`.${CLASS_SUBMENU_OPEN}`).length) {
      this.container.addClass(CLASS_SUBMENU_OPEN);
    } else {
      this.container.removeClass(CLASS_SUBMENU_OPEN);
    }
  }

  toggleSearch(e) {
    this.mobileSearch.toggleClass(CLASS_SEARCH_OPEN);
  }

  cancelEvent(e) {
    e.preventDefault(), e.stopPropagation();
    return true;
  }


  onMenuToggle(e) {
    this.cancelEvent(e) && this.toggleOpen();
  }

  onSubmenuToggle(e) {
    this.cancelEvent(e) && this.toggleSubmenu(e);
  }

  openFirstSubmenu(e) {
    this.firstSubMenuToggle.click();
  }

  onSearchToggle(e) {
    this.cancelEvent(e) && this.toggleSearch();
  }
  
  addRecentlyViewedLink() {
    let html = 
    `<li class="c-mobile-menu__item ">
      <a href="${this.recentlyViewedURL}"
        class="c-mobile-menu__item-title"
        title="${t('layout.header.recently_viewed')}">
        <span>${t('layout.header.recently_viewed')}</span>
        </a>\
      </li>`;

      try {
        let existing = Cookies.getJSON('recent-product-views');
        if(existing && existing.length) {
          this.submenuLast.after(html);
        }
      } catch (error) {
        console.error(`Failed to fetch recently viewed!`+ex)
      }
  }
}
